module.exports = __webpack_public_path__ + "static/fp-01_organizationplanning_@2x-18873d698bf50b84b45ef45794ebcc95.mp4";